var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"mb-0",attrs:{"title":"Total a ser recebido","type":"primary","sub-title":`${_vm.numberToBRL}`,"icon":"ni ni-money-coins"}})
}
var staticRenderFns = []

export { render, staticRenderFns }